import { render, staticRenderFns } from "./item-infoflow.vue?vue&type=template&id=fb6051da&scoped=true&"
import script from "./item-infoflow.vue?vue&type=script&lang=js&"
export * from "./item-infoflow.vue?vue&type=script&lang=js&"
import style0 from "./item-infoflow.vue?vue&type=style&index=0&id=fb6051da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6051da",
  null
  
)

export default component.exports